import { ArrowDownUp } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  columnName: (data: any) => void;
  deleverywaste: (data: any) => void;
}

const ResivewastClumn = ({
  onClickDelete,
  columnName,
  deleverywaste,
}: ColumnsProps) => {
  const ResivewastClumn = useMemo(
    () => 
      [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "نام کشاورز",
        accessorKey: "farmer_name",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("sum_delivered_load")}
          >
            جمع بار تحویلی
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "sum_delivered_load",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("waste_quota_weight")}
          >
            وزن سهمیه تفاله
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "waste_quota_weight",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("waste_quota_price")}
          >
            مبلغ سهمیه تفاله
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "waste_quota_price",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span className="flex" onClick={() => columnName("waste_delivered")}>
            تفاله تحویلی
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "waste_delivered",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: () => (
          <span
            className="flex"
            onClick={() => columnName("waste_deposit_amount")}
          >
            مبلغ واریزی تفاله
            <ArrowDownUp size={15} className="text-blue-500 gap-2" />
          </span>
        ),
        accessorKey: "waste_deposit_amount",
        enableColumnFilter: false,
        cell: ({ getValue }: { getValue: () => any }) => {
          const value = getValue();
          return value ? value.toLocaleString("fa-IR") : "0";
        },
      },
      {
        header: "تحویل",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          return (
            <div>
              <div className="flex gap-3">
                <button
                  className="flex mx-3 items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    deleverywaste(data);
                  }}
                >
                  <span className="rounded p-1 w-20 ml-3 bg-blue-600 text-white">
                    تحویل
                  </span>
                </button>
              </div>
            </div>
          );
        },
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          return (
            <div>
              <div className="flex gap-3 bg-transparent">
                <button
                  className="flex mx-3 items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <span className="rounded p-2  text-center w-full  bg-red-800 text-white">
                    لغو
                  </span>
                </button>
              </div>
            </div>
          );
        },
      },
    ],
    []
  );

  return ResivewastClumn;
};

export default ResivewastClumn;
